module.exports = __webpack_public_path__ + "static/media/042-cloud-storage-2.37d6a506.svg";